import {
  animate,
  animation,
  style,
  transition,
  trigger,
  useAnimation,
} from '@angular/animations';

export type SlideAnimationDirection = 'top' | 'right' | 'bottom' | 'left';

export const slideFadeEnter = animation([
  style({ opacity: 0, transform: '{{ transform }}' }),
  animate('{{ time }}', style({ opacity: 1, transform: 'translate(0)' })),
]);

export const slideFadeLeave = animation([
  style({ opacity: 1, transform: 'translate(0)' }),
  animate('{{ time }}', style({ opacity: 0, transform: '{{ transform }}' })),
]);

export function slideFadeAnimation(
  name: string,
  from: SlideAnimationDirection,
  to: SlideAnimationDirection,
  time = '250ms',
) {
  const transformFrom = generateTranslate(from);
  const transformTo = generateTranslate(to);
  return trigger(name, [
    transition(':enter', [
      useAnimation(slideFadeEnter, {
        params: {
          time,
          transform: transformFrom,
        },
      }),
    ]),
    transition(':leave', [
      useAnimation(slideFadeLeave, {
        params: {
          time,
          transform: transformTo,
        },
      }),
    ]),
  ]);
}

function generateTranslate(direction: SlideAnimationDirection) {
  switch (direction) {
    case 'top':
      return 'translateY(-100%)';
    case 'right':
      return 'translateX(100%)';
    case 'bottom':
      return 'translateY(100%)';
    case 'left':
      return 'translateX(-100%)';
  }
}
